var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectDuraction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4882 5.65857C9.91946 5.65857 9.46045 6.11896 9.46045 6.68537V10.9405C9.46045 11.5098 9.92233 11.9673 10.4882 11.9673H15.005C15.5738 11.9673 16.0328 11.5069 16.0328 10.9405C16.0328 10.3712 15.5709 9.9137 15.005 9.9137H11.5159V6.68698C11.5159 6.11959 11.0575 5.65857 10.4882 5.65857Z",
    fill: "#90C5C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90064 9.37557H4.78107C5.07448 6.16721 7.77761 3.64464 11.0569 3.64464C14.5297 3.64464 17.3591 6.47485 17.3591 9.95548C17.3591 13.4345 14.5314 16.2663 11.0569 16.2663C10.2207 16.2663 9.60656 16.1611 9.09398 15.9742C8.60229 15.7949 8.17468 15.5298 7.71417 15.1624C7.28908 14.6243 6.51495 14.4963 5.93673 14.8886C5.64181 15.0887 5.43609 15.4015 5.36107 15.7341C5.2845 16.0734 5.33655 16.4928 5.65366 16.8099C6.15866 17.3149 6.76869 17.8514 7.63724 18.2548C8.50648 18.6585 9.59914 18.9128 11.0571 18.9128C15.9883 18.9108 20 14.893 20 9.95548C20 5.0179 15.9882 1 11.055 1C6.31633 1 2.42973 4.70727 2.13043 9.37557H0L3.44888 13.5512L6.90064 9.37557Z",
    fill: "#90C5C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDuraction);
export default __webpack_public_path__ + "static/media/Project_Duraction.8de52a9bec1317d7bf6f1922e8fb9512.svg";
export { ForwardRef as ReactComponent };